import styled from "styled-components";
import React, {useEffect, useState} from "react";
import Colors from "../../../assets/colors/Colors";

interface CarretProps {
    opacity: number,
    isLife: boolean
}

const BackCaret = styled.div`
    margin: auto 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 12px solid ${(props: CarretProps) => props.isLife ? Colors.fontWhite : Colors.fontGray };
    height: 0px;
    cursor: pointer;
    opacity: ${(props: CarretProps) => props.opacity};
`;

const FrontCaret = styled.div`
    margin: auto 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 12px solid ${(props: CarretProps) => props.isLife ? Colors.fontWhite : Colors.fontGray };
    height: 0px;
    cursor: pointer;
    opacity: ${(props: CarretProps) => props.opacity};
`;



const PageSelector: React.FC<{handlePageChange: any, pageSelected: any, maxPage: number, isLife: boolean}> = ({pageSelected, handlePageChange, maxPage, isLife}) => {
    const [leftOpacity, setLeftOpacity] = useState(1);
    const [rightOpacity, setRightOpacity] = useState(1);

    //MAYBE USE A REDUCER?
    useEffect(() =>{
        if(pageSelected <= 1){
            setLeftOpacity(0.1);
        } else {
            setLeftOpacity(1);
        }

        if(pageSelected >= maxPage){
            setRightOpacity(0.1);
        } else {
            setRightOpacity(1);
        }
    }, [pageSelected, maxPage]);

    return (
        <div style={{
            display: 'flex',
            marginRight: 100,
            position: 'relative',
            top: 50,
            flexDirection: 'row',
            justifyContent: 'flex-end',
            padding: '5px 5px 5px 10px',
            color: isLife ? Colors.fontWhite : Colors.fontGray
          }}
        >
            <BackCaret opacity={leftOpacity} onClick={() => handlePageChange(-1)} isLife={isLife} />
            <div
              style={{
                marginLeft: 10,
                marginRight: 10,
                fontFamily: 'DMSans-Light'
              }}
            >
              {pageSelected}/{maxPage}
            </div>
            <FrontCaret opacity={rightOpacity} onClick={() => handlePageChange(1)} isLife={isLife} />
        </div>
    )
};

export default PageSelector
